import { memo, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { useFetchCompanies } from '../../api/apiHooks'
import { SearchableInput } from '../SearchableInput'
import { Inputs } from './GenerateMentorForm/GenerateMentorForm'

interface ICompanySelectProps {
  defaultValue?: string
  disabled?: boolean
}

type CompanySelect = { items: string[] }

const CompanySelect: React.FC<ICompanySelectProps> = memo(
  ({ defaultValue, disabled }) => {
    const { setValue } = useFormContext<Inputs>()
    const [searchCompany, setSearchCompany] = useState<string>('')
    const { data, isFetching, hasNextPage, isFetchingNextPage, fetchNextPage } =
      useFetchCompanies(searchCompany, !disabled)

    const handleSearchChange = (query: string) => {
      setSearchCompany(query)
      if (query.trim()) {
        setValue('company', query)
      }
    }

    const searchResult = useMemo(
      () => data?.pages.map((page: CompanySelect) => page.items).flat() ?? [],
      [data],
    )

    const onJobTitleSelect = (value: string) => {
      setValue('company', value)
      if (!value) {
        setSearchCompany('')
      }
    }

    return (
      <SearchableInput
        searchResult={searchResult}
        onSearchChange={handleSearchChange}
        isFetching={isFetching}
        wrapperClassName="tc-mv-input-wrapper"
        placeholder="Start typing..."
        onSelect={onJobTitleSelect}
        fetchNextPage={fetchNextPage}
        needFetchNextPage={hasNextPage && !isFetchingNextPage}
        defaultValue={defaultValue}
        disabled={disabled}
      />
    )
  },
)

export { CompanySelect }
